import * as React from 'react';
import { Route, Switch } from 'react-router';
import { TournamentEvents } from './TournamentEvents';
import { TournamentTeams } from './TournamentTeams';
import { TournamentTeamPlayersManager } from './TournamentTeamPlayersManager';
import { TournamentTeamPlayers } from './TournamentTeamPlayers/TournamentTeamPlayers';
import { TournamentsHub } from './TournamentsHub/TournamentsHub';
import { AdminSchoolsInvitesInbox } from '../Invites/AdminSchoolsInvitesInbox';
import { INVITE_KIND } from 'Src/consts/invite';
import { SchoolTournamentCommunicationsInbox } from './SchoolTournamentCommunicationsInbox';
import {TournamentParticipation} from '../../TournamentParticipation/TournamentParticipation';

export const TournamentRouting = allProps => {
  return (
    <Switch>
      <Route exact path="/tournaments/participation/:section?/:detail?" render={props => <TournamentParticipation {...props} user={allProps.user} />} />
      <Route
        exact
        path={'/tournaments/chats'}
        render={props => <SchoolTournamentCommunicationsInbox {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/tournaments'}
        render={props => <TournamentsHub {...props} user={allProps.user} initialTab="upcoming" />}
      />
      <Route
        exact
        path={'/tournaments/upcoming'}
        render={props => <TournamentsHub {...props} user={allProps.user} initialTab="upcoming" />}
      />
      <Route
        exact
        path={'/tournaments/waitingList'}
        render={props => <TournamentsHub {...props} user={allProps.user} initialTab="waiting" />}
      />
      <Route
        exact
        path={'/tournaments/invites'}
        render={props => <TournamentsHub {...props} user={allProps.user} initialTab="invites" />}
      />
      <Route
        exact
        path={'/tournaments/invites/manage'}
        render={props => (
          <AdminSchoolsInvitesInbox
            {...props}
            user={allProps.user}
            setNeedUpdate={allProps.setNeedUpdate}
            inviteKind={INVITE_KIND.TOURNAMENT_SCHOOL_INVITE}
          />
        )}
      />
      <Route
        exact
        path={'/tournaments/requests'}
        render={props => <TournamentsHub {...props} user={allProps.user} initialTab="requests" />}
      />
      <Route
        exact
        path={'/tournaments/archive'}
        render={props => <TournamentsHub {...props} user={allProps.user} initialTab="archive" />}
      />
      <Route
        exact
        path={'/tournaments/events'}
        render={props => <TournamentEvents {...props} user={allProps.user} />}
      />
      <Route exact path={'/tournaments/teams'} render={props => <TournamentTeams {...props} user={allProps.user} />} />
      <Route
        exact
        path={'/tournaments/teamPlayers/manage'}
        render={props => <TournamentTeamPlayersManager {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/tournaments/teamPlayers'}
        render={props => <TournamentTeamPlayers {...props} user={allProps.user} />}
      />
    </Switch>
  );
};

TournamentRouting.displayName = 'TournamentRouting';
